import EstateObjectType = App.Enums.EstateObject.EstateObjectType

const residentialTypes: EstateObjectType[] = [
  'residential',
  'single_family_house',
  'apartment_building',
  'condominium',
  'two_party_house',
]

const commercialTypes: EstateObjectType[] = [
  'office',
  'commercial',
  'care_and_health',
  'hotel',
  'logistics',
  'wholesale_and_retail',
]

const plotTypes: EstateObjectType[] = ['land']

export const hasLivingSpace = (type: EstateObjectType | null | undefined): boolean =>
  type ? !commercialTypes.includes(type) && !plotTypes.includes(type) : true

export const hasBusinessSpace = (type: EstateObjectType | null | undefined): boolean =>
  type ? !residentialTypes.includes(type) && !plotTypes.includes(type) : true
